import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './components/Home';
import Support from './components/Support';
import Policy from './components/Policy';
import DefaultContact from './components/DefaultContact';
import Subscription from './components/Subscription';
import {FooterHelp, Link} from '@shopify/polaris';

window.$queryString = window.location.search;

function App() {
    return (
        <Router>
            <div className="AppWrapper">
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/login" exact component={Home} />
                    <Route path="/support" component={Support} />
                    <Route path="/policy" component={Policy} />
                    <Route path="/default-contact" exact component={DefaultContact} />
                    <Route path="/subscription" component={Subscription} />
                </Switch>
                <FooterHelp>
                    Contact Form AutoResponder by WebPanda © 2023&nbsp;|&nbsp;
                    <Link url={`/policy${window.$queryString}`}>
                        Privacy Policy
                    </Link>
                </FooterHelp>
                <br/>
            </div>
        </Router>
    )
}

export default App;
